import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './volt/tokens.css';
import './volt/animations.css';
import './globals.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
